import React, { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import { IoBarChart } from "react-icons/io5";
import { FaChartLine } from "react-icons/fa";

const GroupedStackedBarChart = ({ data, from, rotateText }) => {
  // console.log(data);
  const [zoom, setZoom] = useState({ start: 0, end: from === "AF" ? 15 : 6 }); // Initial zoom state
  const [chartType, setChartType] = useState("bar");
  // Define a color mapping for stack names
  const stackColorMap = {
    "16_24": "#5470c6", // Blue for all 00_08 stacks
    "08_16": "#91cc75", // Green for all 08_16 stacks
    "00_08": "#fac858", // Yellow for all 16_24 stacks
  };

  // Calculate series data
  const series = data?.groups?.flatMap((group) =>
    group.stacks.map((stack) => ({
      name: `${group.name} - ${stack.name}`,
      type: chartType,
      stack: group.name,
      emphasis: {
        focus: "series",
      },
      data: stack.data,
      label: {
        show: true,
        position: "inside",
        formatter: "{c}",
        fontSize: 15,
        color: chartType === "bar" ? "#fff" : "#460303ff",
      },
      itemStyle: {
        color: stackColorMap[stack.name],

        shadowColor: "rgba(0, 0, 0, 0.4)",
        shadowBlur: 5,
        shadowOffsetX: 4,
        shadowOffsetY: 0,
        // borderRadius: [4, 4, 0, 0], // optional, for rounded bars
      },
      lineStyle: {
        // color: color,
        width: 3,
        shadowColor: "rgba(0, 0, 0, 0.4)",
        shadowBlur: 4,
        shadowOffsetX: 4,
        shadowOffsetY: 5,
        // borderRadius: [4, 4, 0, 0], // optional, for rounded bars
      },
    }))
  );

  // Calculate totals for each stack (group + category combination)
  const totals = data.categories.map((_, catIndex) => {
    return data.groups.map((group) => {
      const stackTotal = group.stacks.reduce((sum, stack) => {
        return sum + (stack.data[catIndex] || 0);
      }, 0);
      return stackTotal;
    });
  });

  // Create graphic elements for group names below each stack
  const graphicElements = data.categories.flatMap((category, catIndex) =>
    data.groups.map((group, groupIndex) => ({
      type: "text",
      left: "center",
      top: "bottom",
      style: {
        text: group.name,
        textAlign: "center",
        fontSize: 0,
        fontWeight: "bold",
        fill: "red",
      },
      position: [
        (catIndex * 100) / data.categories.length +
          (groupIndex * 50) / data.categories.length +
          10,
        10,
      ],
    }))
  );

  // Create graphic elements for totals above each visible stack
  const totalGraphicElements = () => {
    const totalElements = [];
    const totalBars = data.categories.length * data.groups.length;
    const startIndex = Math.floor((zoom.start / 100) * totalBars);
    const endIndex = Math.min(
      Math.floor((zoom.end / 100) * totalBars),
      totalBars - 1
    );

    for (let barIndex = startIndex; barIndex <= endIndex; barIndex++) {
      const catIndex = Math.floor(barIndex / data.groups.length);
      const groupIndex = barIndex % data.groups.length;
      const total = totals[catIndex][groupIndex];

      totalElements.push({
        type: "text",
        left: "center",
        top: "top",
        style: {
          text: total.toString(),
          textAlign: "center",
          fontSize: 0,
          fontWeight: "bold",
          color: "black",
        },
        position: [
          (catIndex * 100) / data.categories.length +
            (groupIndex * 50) / data.categories.length +
            10,
          -15, // Position above the bar
        ],
      });
    }
    return totalElements;
  };

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
    },
    legend: {
      top: "0%",
      padding: [20, 0, 0, 0],
    },
    grid: {
      top: "15%",
      left: "1%",
      right: "5%",
      bottom: "15%",
      containLabel: true,
    },

    xAxis: {
      type: "category",
      data: data.categories,
      axisLabel: {
        interval: 0,
        fontSize: 12,
        color: "black",
        rotate: rotateText ? rotateText : 0,
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        interval: 0,
        fontSize: 12,
        color: "black",
      },
    },
    dataZoom: [
      {
        type: "slider",
        xAxisIndex: 0,
        start: zoom.start,
        end: zoom.end,
        height: 20,
        bottom: 30,
        handleSize: "100%",
        showDetail: true,
        onChange: (start, end) => setZoom({ start, end }), // Update zoom state on change
      },
      {
        type: "inside",
        xAxisIndex: 0,
        start: zoom.start,
        end: zoom.end,
      },
    ],
    label: { show: false, color: "black" },
    graphic: [...graphicElements, ...totalGraphicElements()], // Include both group names and totals
    series,
    animationDuration: 2000,
    animationEasing: "cubicOut",
    animationDurationUpdate: 1500,
    animationEasingUpdate: "cubicOut",
  };

  return (
    <div>
      <div className="row  d-flex justify-content-end me-2">
        {/* <button
          className="btn btn-outline-dark btn-sm"
          style={{ width: "100px" }}
          onClick={() => {
            setChartType(chartType === "bar" ? "line" : "bar");
          }}
        >
          {chartType === "bar" ? <FaChartLine /> : <IoBarChart />}
        </button> */}
      </div>
      <ReactECharts notMerge={true} option={option} style={{ height: 450 }} />
    </div>
  );
};

export default GroupedStackedBarChart;
